JST["header-auto-suggest-results-fragment"] = function anonymous(it
) {
var out='<ul> ';var arr1=it;if(arr1){var item,i1=-1,l1=arr1.length-1;while(i1<l1){item=arr1[i1+=1];out+=' <li><a href="'+( window.dataLayer.brandCountryPrefixUrl)+'/searchlw?s='+( encodeURIComponent(item) )+'">'+( item )+'</a></li> ';} } out+='</ul>';return out;
};